import { PAWN_COLOUR_KEY } from '@root/constants';

// Cosmetic only. The server never sees a colour, so it lives in the browser.
// Same odds and rewards whichever one is picked.
export const PAWN_COLOURS = ['Yellow', 'Blue', 'Green', 'Red'] as const;

export type PawnColour = (typeof PAWN_COLOURS)[number];

export const DEFAULT_PAWN_COLOUR: PawnColour = 'Yellow';

function isPawnColour(value: unknown): value is PawnColour {
  return PAWN_COLOURS.includes(value as PawnColour);
}

export function readPawnColour(): PawnColour {
  try {
    const stored = localStorage.getItem(PAWN_COLOUR_KEY);
    return isPawnColour(stored) ? stored : DEFAULT_PAWN_COLOUR;
  } catch {
    // Private browsing and blocked storage both throw on read.
    return DEFAULT_PAWN_COLOUR;
  }
}

export function writePawnColour(colour: PawnColour): void {
  try {
    localStorage.setItem(PAWN_COLOUR_KEY, colour);
  } catch {
    // Nothing to surface. The run plays, it just forgets the colour.
  }
}

// Asset keys are suffixed with the colour, e.g. Pawn_Blue, TileBox_Red.
export function colouredAsset(base: string, colour: PawnColour): string {
  return `${base}_${colour}`;
}
